import axios from 'axios'
const HOST_API = process.env.REACT_APP_HOST_API

const axiosInstance = axios.create({ baseURL: HOST_API })

export default axiosInstance
